export function getInputProps(view_type, readOnlyMargin) {
    switch (view_type) {
        case ('detail'): {
            return {
                readOnly:         true,
                disableUnderline: true,
                className:        readOnlyMargin
            }
        }
        default: {
            return {}
        };
    }
}

export function getSharedTextFieldProps(view_type, classes) {
    return {
        InputProps: getInputProps(view_type, classes.readOnlyMargin),
        variant:    view_type === 'detail' ? "standard" : "outlined",
        margin:     'normal',
        className:  classes.textField
    }
}


// WEBPACK FOOTER //
// src/main/components/helpers/SharedTextField.js